export function tagsWithIds(state = [], action) {

  if (action.type === 'GET_TAG_PARSED_WITH_IDS') {
    return action.tags_with_ids || null;
  }

  return state;
}
